import { FromSchema } from '@40seas/entities/common';
import { z } from 'zod';
import { Fee, FeeSchema } from '../fee.entity';
import { PaymentOption, PaymentOptionSchema } from './payment-option.entity';

export const PaymentOptionWithFeeSchema = z
    .object({
        paymentOption: PaymentOptionSchema,
        paymentFee: FeeSchema.optional(), // TODO: FS-5663 remove field
        feeDefinition: z.string().optional(), // TODO: FS-5663 remove field
        paymentFees: z.array(FeeSchema).optional(), // TODO: FS-5663 remove optional
    })
    .strict();
export class PaymentOptionWithFee extends FromSchema(PaymentOptionWithFeeSchema) {
    paymentOption: PaymentOption;
    paymentFee?: Fee; // TODO: FS-5663 remove field
    feeDefinition?: string; // TODO: FS-5663 remove field
    paymentFees?: Fee[]; // TODO: FS-5663 remove optional
}
